var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { observable, action } from 'mobx';
import { api, updateHeaders } from 'helpers/Api';
import { User } from './Model';
import Storage from 'helpers/Storage';
import { Role } from './Model';
import { t } from 'helpers/i18n';
import { store } from 'App';
export default class default_1 {
    constructor(stor) {
        this.users = [];
        this.loaded = false;
        this.changePassword = (password) => {
            return api.put('/user/' + this.user.id, { password });
        };
        this.login = (payload) => {
            payload['type'] = 'app';
            payload['sn'] = 'DEMO000033';
            return api.post('login', payload)
                .then(response => {
                if (response.role === Role.Virtual) {
                    return this.persist(response);
                    // Storage.set(USER_KEY, response)
                    // this.user = new User(response)
                    // updateHeaders(response.token, response.client)
                    // this.store.cashDeskTicketStore.isOpen()
                }
                else {
                    throw store.UI.newError(t('error:userNoAccess'));
                }
            })
                .then(this.store.initRemainder)
                .then(value => this.store.cashDeskTicketStore.open());
        };
        this.setUser = (user) => {
            this.user = new User(user);
        };
        this.persist = (user) => __awaiter(this, void 0, void 0, function* () {
            console.log('UsersStore - persist - user: ', user);
            this.setUser(user);
            updateHeaders(user.token, user.client);
            Storage.set(USER_KEY, user);
            return this.user;
        });
        this.logout = () => __awaiter(this, void 0, void 0, function* () {
            Storage.remove(USER_KEY);
            this.store.init();
            api.post('logout/' + this.user.id);
            window.location.reload();
        });
        this.recovery = (payload) => {
            return api.post('user/recovery', payload).then();
        };
        this.fingById = (id) => {
            return this.users.filter(value => value.id === id)[0];
        };
        this.set = (users) => {
            this.users = users.map(user => new User(user));
            this.loaded = true;
        };
        this.push = (user) => {
            this.users.push(new User(user));
        };
        this.replace = (user) => {
            this.users.splice(this.users.findIndex(f => f.id === user.id), 1, user);
        };
        this.pull = (user) => {
            this.users.splice(this.users.findIndex(a => a.id === user.id), 1);
        };
        this.store = stor;
        this.rehydrate();
    }
    rehydrate() {
        // console.log('User/Store - rehydrate')
        let user = Storage.getJSON(USER_KEY);
        if (user) {
            this.user = new User(user);
            updateHeaders(user.token, user.client);
        }
    }
    read(id) {
        if (id)
            return api.get('user/' + id).then(user => new User(user));
        return api.get(USER_KEY).then(this.set);
    }
    create(user) {
        return api.post('user', user).then(this.push);
    }
    update(id, user) {
        return api.put('user/' + id, user).then(this.replace);
    }
    disable(id, disabled) {
        return api.patch('user/' + id, { disabled }).then(this.pull);
    }
    addCaja(id, importe, numero) {
        return __awaiter(this, void 0, void 0, function* () {
            const user = this.user.id;
            let caja = yield this.getCaja(user);
            // console.log('antes - addCaja - caja: ', caja)
            if (id === null) { // reset
                // caja.ids = []
                caja.importes = 0;
            }
            else {
                if (!caja.numeros) {
                    caja.numeros = [];
                }
                if (!caja.ids) {
                    caja.ids = [];
                }
                caja.numeros.push(numero);
                // caja.ids.push(id)
                console.log('importe: ', importe);
                console.log('typeof importe: ', typeof importe);
                console.log('typeof caja.importes: ', typeof caja.importes);
                caja.importes += importe;
            }
            yield Storage.set(user.toString(), caja);
            caja = yield this.getCaja(this.user.id);
            // console.log('despues - addCaja', caja)
        });
    }
    getCaja(user) {
        return __awaiter(this, void 0, void 0, function* () {
            // return {ids: [44, 46], importes: 100}
            const result = yield Storage.get(user.toString());
            // console.log('getCaja - typeof result', typeof result)
            return JSON.parse(result);
        });
    }
}
__decorate([
    observable
], default_1.prototype, "users", void 0);
__decorate([
    observable
], default_1.prototype, "user", void 0);
__decorate([
    observable
], default_1.prototype, "loaded", void 0);
__decorate([
    action
], default_1.prototype, "setUser", void 0);
__decorate([
    action
], default_1.prototype, "set", void 0);
__decorate([
    action
], default_1.prototype, "push", void 0);
__decorate([
    action
], default_1.prototype, "replace", void 0);
__decorate([
    action
], default_1.prototype, "pull", void 0);
export const USER_KEY = 'user';



//////////////////
// WEBPACK FOOTER
// ./src/modules/Users/Store.ts
// module id = 335
// module chunks = 0